import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { LanguageProvider } from "./Component/LanguageContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
      <div className="App">

            <LanguageProvider>
    <App />
            </LanguageProvider>
                </div>

);

